(function ($) {
    $(window).load(function () {
        //fancybox
        $('.gallery_section').each(function () {
            $(this).find('.fancy').fancybox({
                afterLoad: function (el) {
                    if (typeof el.current !== 'undefined'
                        && typeof el.current.src !== 'undefined'
                        && el.current.src.match(/^#panorama/)
                    ) {
                        var outerDiv = $(el.current.src);
                        if (outerDiv.data('pannellum')) {
                            //360 images
                            //Finding this attribute means that the div is a pannellum container
                            var innerDivId = el.current.src.replace(/^#/, '') + '_inner';
                            var imageUrl = outerDiv.data('pannellum');
                            pannellum.viewer(innerDivId, {
                                "type": "equirectangular",
                                "panorama": imageUrl,
                                "autoLoad": true,
                                "compass": true
                            });
                        }
                    }

                }
            });
        });
    });
}(jQuery));
